import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=5d7e47c6&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shopList.vue?vue&type=style&index=1&id=5d7e47c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e47c6",
  null
  
)

component.options.__file = "shopList.vue"
export default component.exports